module.exports = __webpack_public_path__ + "static/media/RevisedIllustration.d3656f9d.png";